module.exports = __webpack_public_path__ + "assets/images/albom1.f28ddd72.jpg";